const ClientMilestoneTypes = {
    ADD_CLIENT_MILESTONE: 'ADD_CLIENT_MILESTONE',
    ADD_CLIENT_MILESTONE_LOADING: 'ADD_CLIENT_MILESTONE_LOADING',
    ADD_CLIENT_MILESTONE_SUCCESS: 'ADD_CLIENT_MILESTONE_SUCCESS',
    ADD_CLIENT_MILESTONE_ERROR: 'ADD_CLIENT_MILESTONE_ERROR',
    ADD_CLIENT_MILESTONE_RESET: 'ADD_CLIENT_MILESTONE_RESET',

    GET_CLIENT_MILESTONES: 'GET_CLIENT_MILESTONES',
    GET_CLIENT_MILESTONES_LOADING: 'GET_CLIENT_MILESTONES_LOADING',
    GET_CLIENT_MILESTONES_SUCCESS: 'GET_CLIENT_MILESTONES_SUCCESS',
    GET_CLIENT_MILESTONES_ERROR: 'GET_CLIENT_MILESTONES_ERROR',
    GET_CLIENT_MILESTONES_RESET: 'GET_CLIENT_MILESTONES_RESET',

    ADD_CLIENT_TASK: 'ADD_CLIENT_TASK',
    ADD_CLIENT_TASK_LOADING: 'ADD_CLIENT_TASK_LOADING',
    ADD_CLIENT_TASK_SUCCESS: 'ADD_CLIENT_TASK_SUCCESS',
    ADD_CLIENT_TASK_ERROR: 'ADD_CLIENT_TASK_ERROR',
    ADD_CLIENT_TASK_RESET: 'ADD_CLIENT_TASK_RESET',

    GET_CLIENT_TASKS: 'GET_CLIENT_TASKS',
    GET_CLIENT_TASKS_LOADING: 'GET_CLIENT_TASKS_LOADING',
    GET_CLIENT_TASKS_SUCCESS: 'GET_CLIENT_TASKS_SUCCESS',
    GET_CLIENT_TASKS_ERROR: 'GET_CLIENT_TASKS_ERROR',
    GET_CLIENT_TASKS_RESET: 'GET_CLIENT_TASKS_RESET',

    UPDATE_CLIENT_TASK: 'UPDATE_CLIENT_TASK',
    UPDATE_CLIENT_TASK_LOADING: 'UPDATE_CLIENT_TASK_LOADING',
    UPDATE_CLIENT_TASK_SUCCESS: 'UPDATE_CLIENT_TASK_SUCCESS',
    UPDATE_CLIENT_TASK_ERROR: 'UPDATE_CLIENT_TASK_ERROR',
    UPDATE_CLIENT_TASK_RESET: 'UPDATE_CLIENT_TASK_RESET',

    UPDATE_CLIENT_MILESTONE: 'UPDATE_CLIENT_MILESTONE',
    UPDATE_CLIENT_MILESTONE_LOADING: 'UPDATE_CLIENT_MILESTONE_LOADING',
    UPDATE_CLIENT_MILESTONE_SUCCESS: 'UPDATE_CLIENT_MILESTONE_SUCCESS',
    UPDATE_CLIENT_MILESTONE_ERROR: 'UPDATE_CLIENT_MILESTONE_ERROR',
    UPDATE_CLIENT_MILESTONE_RESET: 'UPDATE_CLIENT_MILESTONE_RESET',
    
};

export default ClientMilestoneTypes;
